import { LeadsDataSource } from '../../../utils/apis/leadsApiUtils';
import { getDeltas, isBasePeriod } from '../../../utils/dataUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
export const getTotalLeadsChartColors = (chartData, colors) => {
    const labelsWithColors = chartData.map(({ label }) => ({
        label,
        color: colors[label],
    }));
    return labelsWithColors
        .filter(({ color }) => color !== undefined)
        .reduce((acc, { label, color }) => ({
        ...acc,
        [label]: color,
    }), {});
};
// Add more mappings as needed
export const formatTypeName = (typeName) => ({
    PreviousCustomer: 'Previous Customer',
    WebsiteChat: 'Website Chat',
    PartsOrder: 'Parts Order',
}[typeName]) || typeName;
export const getTotalLeadsSourceLink = (source, dateRange) => {
    if (source === LeadsDataSource.VIN_SOLUTIONS) {
        return 'https://www.vinsolutions.com';
    }
    return getNvisionAnalyzeLeadsUrl(dateRange);
};
export const getFormattedTotalLeadsData = (response, formatMessage) => {
    const { lastUpdatedUTC, leadTypesSegments = [] } = (response || {});
    const baseTotalLeads = leadTypesSegments.find(({ comparisonPeriod }) => isBasePeriod(comparisonPeriod));
    const { leadTypes, totalLeads = 0, } = baseTotalLeads || {};
    const chartData = (leadTypes || []).map(({ typeName, leadTypesCount }) => ({
        label: formatMessage({
            id: `LEAD_TYPE.${typeName.toUpperCase().replace('-', '_')}`,
            // Changes like 'PreviousCustomer' to 'Previous Customer'
            // for web components that don't have access to translations
            defaultMessage: formatTypeName(typeName),
        }),
        value: leadTypesCount,
    }));
    const deltas = getDeltas(leadTypesSegments);
    return {
        chartData,
        deltas,
        totalLeads,
        lastUpdatedUTC: lastUpdatedUTC || '',
    };
};
